import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { parseISO } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class CustomNgbDateAdapter extends NgbDateAdapter<Date> {
  fromModel(date: Date | string): NgbDateStruct {
    if (date instanceof Date) {
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
    }

    if (typeof date === 'string') {
      const parsedDate = parseISO(date);
      return {
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth() + 1,
        day: parsedDate.getDate(),
      };
    }

    return undefined;
  }

  toModel(date: NgbDateStruct): Date {
    return date && date.year && date.month ? new Date(Date.UTC(date.year, date.month - 1, date.day)) : undefined;
  }
}
